import React from 'react';

const ATTACHMENTS_FTP = process.env.REACT_APP_ATTACHMENTS_FTP;
const ATTACHMENTS_FTP_MATERIALS_FOLDER = process.env.REACT_APP_ATTACHMENTS_FTP_MATERIALS_FOLDER;
const ATTACHMENTS_FTP_USERNAME = process.env.REACT_APP_ATTACHMENTS_FTP_USERNAME;
const ATTACHMENTS_FTP_PASSWORD = process.env.REACT_APP_ATTACHMENTS_FTP_PASSWORD;
const MMASS_FTP = `ftp://${encodeURIComponent(ATTACHMENTS_FTP_USERNAME)}:${encodeURIComponent(
  ATTACHMENTS_FTP_PASSWORD
)}@${ATTACHMENTS_FTP}`;

const getDaysArray = (amount) => Array.from({ length: amount }, (_, i) => i + 1);

const isWeekendFromDate = (options) => {
  const { date, day, month, year } = options;
  let dayNumber;
  if (date) {
    dayNumber = new Date(`${date}T10:10`).getDay();
  } else {
    dayNumber = new Date(year, month - 1, day).getDay();
  }
  const weekend = dayNumber === 0 || dayNumber === 6;
  return weekend;
};

const OrderTableSalidas = ({ djangoRows, results, onClickOrderAttachment }) => {
  const getFileLink = (file) => {
    return `${MMASS_FTP}/${ATTACHMENTS_FTP_MATERIALS_FOLDER}/${file}`;
  };

  const valueForDay = (days, year, month, day) => {
    const dayNumber = day < 10 ? `0${day}` : day;
    const monthNumber = month < 10 ? `0${month}` : month;
    const dayKey = `${year}-${monthNumber}-${dayNumber}`;
    const value = days[dayKey];
    return value || '';
  };

  // Helper para obtener icono según tipo de publicidad
  const getAdvertisementIcon = (type) => {
    const typeMap = {
      'TV': 'fas fa-tv',
      'Radio': 'fas fa-radio',
      'Digital': 'fas fa-laptop',
      'Prensa': 'fas fa-newspaper',
      'Via Publica': 'fas fa-road'
    };
    return typeMap[type] || 'fas fa-bullhorn';
  };

  // Helper para badge de ámbito
  const getAmbitoDisplay = (ambitoTar) => {
    if (ambitoTar === 2) {
      return (
        <span className="tag is-info is-light is-medium">
          <span className="icon is-medium mr-1">
            <i className="fas fa-globe"></i>
          </span>
          <span className="is-size-6">Nacional</span>
        </span>
      );
    }
    return (
      <span className="tag is-primary is-light is-medium">
        <span className="icon is-medium mr-1">
          <i className="fas fa-map-marker-alt"></i>
        </span>
        <span className="is-size-6">Local</span>
      </span>
    );
  };

  // Helper para estado de descarga
  const getDownloadStatus = (downloaded) => {
    if (downloaded === "Si") {
      return (
        <span className="tag is-success is-light is-medium">
          <span className="icon is-medium mr-1">
            <i className="fas fa-check-circle"></i>
          </span>
          <span className="is-size-6">Sí</span>
        </span>
      );
    }
    return (
      <span className="tag is-warning is-light is-medium">
        <span className="icon is-medium mr-1">
          <i className="fas fa-clock"></i>
        </span>
        <span className="is-size-6">Pendiente</span>
      </span>
    );
  };

  return (
    <>
      <div className="table-container">
        <table className="table is-bordered is-fullwidth is-hoverable mb-0">
          <tbody>
            {/* Header de meses */}
            <tr className="has-background-primary">
              <td colSpan="6" className="has-background-primary"></td>
              {djangoRows.months.map(({ days_in_month: daysInMonth, name }, monthIndex) => (
                <th 
                  key={`month-${monthIndex}`}
                  colSpan={`${daysInMonth}`} 
                  scope="colgroup" 
                  className="is-capitalized has-text-white has-text-centered has-text-weight-semibold"
                  style={{ minWidth: '120px' }}
                >
                  <span 
                    className="icon-text" 
                    style={{
                      display: 'flex !important',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexWrap: 'nowrap',
                      whiteSpace: 'nowrap'
                    }}
                  >
                    <span className="icon is-small" style={{ flexShrink: 0, marginRight: '0.5rem' }}>
                      <i className="fas fa-calendar-alt"></i>
                    </span>
                    <span style={{ flexShrink: 0 }}>{name}</span>
                  </span>
                </th>
              ))}
            </tr>

            {/* Header de columnas */}
            <tr className="has-background-light">
              <th className="has-text-weight-semibold" style={{ minWidth: '140px' }}>
                <span 
                  className="icon-text"
                  style={{
                    display: 'flex !important',
                    alignItems: 'center',
                    flexWrap: 'nowrap',
                    whiteSpace: 'nowrap'
                  }}
                >
                  <span className="icon is-small" style={{ flexShrink: 0, marginRight: '0.5rem' }}>
                    <i className="fas fa-clock"></i>
                  </span>
                  <span style={{ flexShrink: 0 }}>Sector Horario</span>
                </span>
              </th>
              <th className="has-text-weight-semibold" style={{ minWidth: '120px' }}>
                <span 
                  className="icon-text"
                  style={{
                    display: 'flex !important',
                    alignItems: 'center',
                    flexWrap: 'nowrap',
                    whiteSpace: 'nowrap'
                  }}
                >
                  <span className="icon is-small" style={{ flexShrink: 0, marginRight: '0.5rem' }}>
                    <i className="fas fa-file-video"></i>
                  </span>
                  <span style={{ flexShrink: 0 }}>Material</span>
                </span>
              </th>
              <th className="has-text-weight-semibold" style={{ minWidth: '100px' }}>
                <span 
                  className="icon-text"
                  style={{
                    display: 'flex !important',
                    alignItems: 'center',
                    flexWrap: 'nowrap',
                    whiteSpace: 'nowrap'
                  }}
                >
                  <span className="icon is-small" style={{ flexShrink: 0, marginRight: '0.5rem' }}>
                    <i className="fas fa-stopwatch"></i>
                  </span>
                  <span style={{ flexShrink: 0 }}>Duración</span>
                </span>
              </th>
              <th className="has-text-weight-semibold" style={{ minWidth: '120px' }}>
                <span 
                  className="icon-text"
                  style={{
                    display: 'flex !important',
                    alignItems: 'center',
                    flexWrap: 'nowrap',
                    whiteSpace: 'nowrap'
                  }}
                >
                  <span className="icon is-small" style={{ flexShrink: 0, marginRight: '0.5rem' }}>
                    <i className="fas fa-bullhorn"></i>
                  </span>
                  <span style={{ flexShrink: 0 }}>Publicidad</span>
                </span>
              </th>
              <th className="has-text-weight-semibold" style={{ minWidth: '100px' }}>
                <span 
                  className="icon-text"
                  style={{
                    display: 'flex !important',
                    alignItems: 'center',
                    flexWrap: 'nowrap',
                    whiteSpace: 'nowrap'
                  }}
                >
                  <span className="icon is-small" style={{ flexShrink: 0, marginRight: '0.5rem' }}>
                    <i className="fas fa-map"></i>
                  </span>
                  <span style={{ flexShrink: 0 }}>Ámbito</span>
                </span>
              </th>
              <th className="has-text-weight-semibold" style={{ minWidth: '120px' }}>
                <span 
                  className="icon-text"
                  style={{
                    display: 'flex !important',
                    alignItems: 'center',
                    flexWrap: 'nowrap',
                    whiteSpace: 'nowrap'
                  }}
                >
                  <span className="icon is-small" style={{ flexShrink: 0, marginRight: '0.5rem' }}>
                    <i className="fas fa-download"></i>
                  </span>
                  <span style={{ flexShrink: 0 }}>Descargado</span>
                </span>
              </th>
              {djangoRows.months.map(({ days_in_month: daysInMonth, month, year }, monthIndex) =>
                getDaysArray(daysInMonth).map((day) => (
                  <th
                    key={`header-${monthIndex}-${day}`}
                    className={`has-text-centered has-text-weight-semibold ${
                      isWeekendFromDate({ day, month, year }) 
                        ? 'has-background-grey-light has-text-grey-dark' 
                        : ''
                    }`}
                    scope="col"
                    style={{ minWidth: '35px' }}
                  >
                    {day}
                  </th>
                ))
              )}
            </tr>

            {/* Filas de datos */}
            {djangoRows.material_rows.map(({
              media: mediaName, 
              hour_range: hourRange, 
              file_name: fileName, 
              material_name: material, 
              duration, 
              days, 
              downloaded, 
              attachment_id: attachmentId, 
              ambito_tar: ambitoTar, 
              advertisement_type: advertisementType
            }, index) => (
              <tr key={`material-${index}`} className="is-size-6">
                <td className="has-text-weight-semibold">
                  <span 
                    className="icon-text"
                    style={{
                      display: 'flex !important',
                      alignItems: 'center',
                      flexWrap: 'nowrap',
                      whiteSpace: 'nowrap'
                    }}
                  >
                    <span className="icon is-small has-text-primary" style={{ flexShrink: 0, marginRight: '0.5rem' }}>
                      <i className="fas fa-clock"></i>
                    </span>
                    <span style={{ flexShrink: 0 }}>{hourRange}</span>
                  </span>
                </td>
                <td>
                  {fileName ? (
                    <button
                      className="button is-link is-outlined is-medium has-text-weight-semibold"
                      onClick={(e) => onClickOrderAttachment(e, getFileLink(fileName), fileName, attachmentId)}
                      title="Descargar material"
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'nowrap',
                        whiteSpace: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis'
                      }}
                    >
                      <span className="icon is-medium" style={{ flexShrink: 0, marginRight: '0.5rem' }}>
                        <i className="fas fa-download"></i>
                      </span>
                      <span style={{ flexShrink: 1, overflow: 'hidden', textOverflow: 'ellipsis' }}>{material}</span>
                    </button>
                  ) : (
                    <span 
                      className="has-text-weight-semibold has-text-grey"
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        flexWrap: 'nowrap',
                        whiteSpace: 'nowrap'
                      }}
                    >
                      <span className="icon is-medium" style={{ flexShrink: 0, marginRight: '0.5rem' }}>
                        <i className="fas fa-file"></i>
                      </span>
                      <span style={{ flexShrink: 0 }}>{material}</span>
                    </span>
                  )}
                </td>
                <td className="has-text-centered">
                  <span 
                    className="tag is-white is-medium"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      flexWrap: 'nowrap',
                      whiteSpace: 'nowrap'
                    }}
                  >
                    <span className="icon is-medium" style={{ flexShrink: 0, marginRight: '0.25rem' }}>
                      <i className="fas fa-stopwatch"></i>
                    </span>
                    <span className="is-size-6" style={{ flexShrink: 0 }}>{duration} Seg.</span>
                  </span>
                </td>
                <td>
                  <span 
                    className="icon-text"
                    style={{
                      display: 'flex !important',
                      alignItems: 'center',
                      flexWrap: 'nowrap',
                      whiteSpace: 'nowrap'
                    }}
                  >
                    <span className={`icon is-medium has-text-info`} style={{ flexShrink: 0, marginRight: '0.5rem' }}>
                      <i className={getAdvertisementIcon(advertisementType)}></i>
                    </span>
                    <span className="has-text-weight-semibold" style={{ flexShrink: 0 }}>{advertisementType}</span>
                  </span>
                </td>
                <td>
                  {getAmbitoDisplay(ambitoTar)}
                </td>
                <td>
                  {getDownloadStatus(downloaded)}
                </td>
                {djangoRows.months.map(({ days_in_month: daysInMonth, month, year }, monthIndex) =>
                  getDaysArray(daysInMonth).map((day) => (
                    <td
                      key={`data-${index}-${monthIndex}-${day}`}
                      className={`has-text-centered has-text-weight-semibold ${
                        isWeekendFromDate({ day, month, year }) 
                          ? 'has-background-grey-light' 
                          : ''
                      }`}
                    >
                      {valueForDay(days, year, month, day) && (
                        <span className="tag is-success is-light is-small">
                          {valueForDay(days, year, month, day)}
                        </span>
                      )}
                    </td>
                  ))
                )}
              </tr>
            ))}
          </tbody>
        </table>

        {/* Leyenda informativa */}
        <div className="box is-shadowless has-background-light mt-3 p-4 is-size-6">
          <div className="content is-small">
            <p className="has-text-weight-semibold mb-2 has-text-grey-dark">
              <span className="icon mr-2">
                <i className="fas fa-info-circle"></i>
              </span>
              Información de la tabla:
            </p>
            <div className="columns is-mobile is-multiline">
              <div className="column is-half-mobile is-one-third-tablet">
                <span className="icon-text is-size-6">
                  <span className="has-background-grey-light px-2 py-1 mr-2"></span>
                  <span>Fines de semana</span>
                </span>
              </div>
              <div className="column is-half-mobile is-one-third-tablet">
                <span className="icon-text is-size-6">
                  <span className="tag is-success is-light is-medium mr-2">✓</span>
                  <span>Programado</span>
                </span>
              </div>
              <div className="column is-half-mobile is-one-third-tablet">
                <span className="icon-text is-size-6">
                  <span className="icon is-medium mr-2 has-text-link">
                    <i className="fas fa-download"></i>
                  </span>
                  <span>Clic para descargar</span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderTableSalidas;